/* global window */
'use strict';

module.exports = require('./ponyfill')(global || window || this);



/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/symbol-observable/0.2.4/symbol-observable/index.js
 ** module id = 677
 ** module chunks = 0
 **/